import { useState } from "react";

import { PromptDataProfileEditForm } from "src/app/features/PromptDataProfile/components/forms/PromptDataProfileEditForm";
import { ActionBar } from "../../../../components/ActionBar/ActionBar";
import { PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { FPage, FPageContent, FPageHeader } from "../../../../components/AppLayout/components/FPageLayout";
import { BackButton } from "../../../../components/FeatureButtons/BackButton";
import { SubmitButton } from "../../../../components/FeatureButtons/SubmitButton";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import { BASE_PATH } from "../../../../core/router/types/routerTypes";

export const PromptDataProfileEditFormPage = () => {
    const [runSubmit, setRunSubmit] = useState(0);
    const triggerFormSubmit = () => setRunSubmit(runSubmit + 1);
    const hasWriteAccess = canAccess(ResourceName.PROMPT_DATA_PROFILES, "canWrite");

    return (
        <FPage>
            <FPageHeader>
                <PageTitle translationKey="page.title.promptDataProfilesEditFormPage" />
                <ActionBar>
                    <SubmitButton isDisabled={!hasWriteAccess} onClick={triggerFormSubmit} />
                    <BackButton isDisabled={false} url={`${BASE_PATH}/${ResourceName.PROMPT_DATA_PROFILES}`} />
                </ActionBar>
            </FPageHeader>
            <FPageContent>
                <PromptDataProfileEditForm runSubmit={runSubmit} />
            </FPageContent>
        </FPage>
    );
};
